export default function ($) {

        $(".cookie-panel").click (function() {
            Didomi.preferences.show()
        });
 
}
